export default __webpack_public_path__ + "static/media/logs_2.2793093e.png";